import { jsx as a, jsxs as p } from "react/jsx-runtime";
import { useState as C, useEffect as v } from "react";
import { Checkbox as b } from "./Checkbox.mjs";
const I = (k) => {
  const {
    legend: h,
    message: t,
    helpText: c,
    error: i,
    reference: f,
    options: l,
    onOptionsSelected: s,
    testId: e
  } = k, [n, m] = C(
    l ?? []
  ), g = (r) => {
    const o = n.map(
      (d) => r === d.name ? { ...d, checked: !d.checked } : d
    );
    m(o);
  };
  v(() => {
    s == null || s(n);
  }, [n, s]), v(() => {
    m(l ?? []);
  }, [l]);
  const x = [
    i && t ? "errorContainer" : "",
    c ? "helpContainer" : ""
  ].filter(Boolean).join(" "), u = /* @__PURE__ */ a(
    "ul",
    {
      className: "checkbox-list",
      "data-testid": e ? `${e}-list` : void 0,
      children: n.map((r, o) => {
        const d = `custom-checkbox-${r.name}`;
        return /* @__PURE__ */ a("li", { children: /* @__PURE__ */ a(
          b,
          {
            id: d,
            name: r.name,
            value: r.value,
            label: r.value,
            checked: r.checked,
            onChange: () => g(r.name),
            reference: f,
            testId: e
          }
        ) }, `${r.name}-${o}`);
      })
    }
  );
  return /* @__PURE__ */ p(
    "fieldset",
    {
      className: "Form-group",
      "aria-invalid": i ? "true" : void 0,
      "aria-describedby": x || void 0,
      "data-testid": e ? `${e}-fieldset` : void 0,
      children: [
        h && /* @__PURE__ */ a("legend", { className: "u-marginBottom8", children: h }),
        i ? /* @__PURE__ */ a("div", { className: "RadioCheckbox-wrapper Input--error", children: u }) : u,
        i && t && /* @__PURE__ */ a("ul", { id: "errorContainer", children: /* @__PURE__ */ p(
          "li",
          {
            className: "Form-help Form-help--error",
            "data-testid": e ? `${e}-message` : void 0,
            children: [
              /* @__PURE__ */ a(
                "span",
                {
                  "data-testid": e ? `${e}-warning` : void 0,
                  "aria-hidden": "true",
                  children: "warning"
                }
              ),
              /* @__PURE__ */ a("span", { className: "u-hiddenVisually", children: "Error," }),
              /* @__PURE__ */ a("span", { children: t })
            ]
          }
        ) }),
        c && /* @__PURE__ */ a("ul", { id: "helpContainer", children: /* @__PURE__ */ a(
          "li",
          {
            className: "Form-help",
            "data-testid": e ? `${e}-helpText` : void 0,
            children: c
          }
        ) })
      ]
    }
  );
};
export {
  I as CheckboxList
};
//# sourceMappingURL=CheckboxList.mjs.map
